module.exports = __webpack_public_path__ + "img/Home.3ef03edd.jpeg";